// @formatter:off
( function(root, factory) {
    if ( typeof define === 'function' && define.amd) {
        define('mmc.libs.ShareIconsModule',['jquery','underscore'], factory);
    } else if ( typeof exports === 'object') {
        module.exports = factory(require('jquery','underscore'));
    } else {
        if ( typeof root.MMCLIBS === 'object') {
            root.MMCLIBS.ShareModule = factory(root.$, root._);
        } else {
            root.ShareModule = factory(root.$, root._);
        }
    }
}(this, function(
    $, _
) {
// @formatter:off

    function ShareModule(settings) {

        var defaults = {
            $container : null,

            trackingHelper : null,

            facebook : {
                shareURL : '',
                appid : '',
                width : 500,
                height : 400
            },
            twitter : {
                shareURL : '',
                text : '',
                width : 500,
                height : 250
            },
            email : {
                subject : 'email-subject',
                body : 'email-body'
            },
            pinterest : {
                shareURL : '',
                description : '',
                media : ''
            }
        };

        settings = $.extend({}, defaults, settings);

        var share_module = {

            settings : {},

            shareUrl : '',

            DOM : {},

            trackingHelper : null,

            init : function(settings) {
                _.bindAll.apply(_, [this].concat(_.functions(this)));
                this.settings = settings;
                this.shareURL = location.href.replace(location.hash, '').replace('#', '');

                // init trackinghelper
                if ( typeof this.settings.trackingHelper === 'object') {
                    this.trackingHelper = this.settings.trackingHelper;
                } else {
                    this.trackingHelper = {
                        track : function() {}
                    };
                }

                // init dom elements
                if (typeof this.settings.$container === 'string') {
                    this.DOM.$container = $(this.settings.$container);
                } else if (typeof this.settings.$container === 'object'&&this.settings.$container instanceof $) {
                    this.DOM.$container = this.settings.$container;
                } else {
                    return;
                }
                this.initDOM();
                this.initButtons();
            },

            initDOM : function() {
                this.DOM.$email = this.DOM.$container.find('.email.share');
                this.DOM.$fb = this.DOM.$container.find('.facebook.share');
                this.DOM.$tw = this.DOM.$container.find('.twitter.share');
                this.DOM.$pi = this.DOM.$container.find('.pinterest.share');
            },

            initButtons : function() {
                var that = this;

                this.DOM.$email.on('click', this.shareViaMail);
                this.DOM.$fb.on('click', this.shareOnFacebook);
                this.DOM.$tw.on('click', this.shareOnTwitter);
                this.DOM.$pi.on('click', this.shareOnPinterest);
            },

            shareOnFacebook : function(e) {
                e.preventDefault();
                var shareURL = (this.settings.facebook.shareURL !== '') ? this.settings.facebook.shareURL : this.shareURL;
                var encodedURL = encodeURIComponent(shareURL);
                var sharer = window.open('http://facebook.com/sharer.php?app_id=' + this.settings.facebook.appid + '&u=' + encodedURL + '&display=popup&ref=plugin', 'shareonfacebook', 'width=' + this.settings.facebook.width + ',height=' + this.settings.facebook.height + ',resizable=yes');
                sharer.focus();
            },

            shareOnTwitter : function(e) {
                e.preventDefault();
                var encodedText = encodeURIComponent(this.settings.twitter.text);
                var shareURL = (this.settings.twitter.shareURL !== '') ? this.settings.twitter.shareURL : this.shareURL;
                var encodedURL = encodeURIComponent(shareURL);
                var sharer = window.open('https://twitter.com/intent/tweet?text=' + encodedText + '&url=' + encodedURL, 'shareontwitter', 'width=' + this.settings.twitter.width + ',height=' + this.settings.twitter.height + ',resizable=yes');
                sharer.focus();
            },

            shareViaMail : function(e) {
                e.preventDefault();
                var link = 'mailto:?subject=' + encodeURIComponent(this.settings.email.subject) + '&body=' + encodeURIComponent(this.settings.email.body);
                location.href = link;
            },

            shareOnPinterest : function(e) {
                e.preventDefault();
                var encodedDescription = encodeURIComponent(this.settings.pinterest.description);
                var encodedMedia = encodeURIComponent(this.settings.pinterest.media);
                var shareURL = (this.settings.pinterest.shareURL !== '') ? this.settings.pinterest.shareURL : this.shareURL;
                var encodedURL = encodeURIComponent(shareURL);
                var sharer = window.open('http://pinterest.com/pin/create/button/?description=' + encodedDescription + '&url=' + encodedURL + ((this.settings.pinterest.media !== '') ? '&media=' + encodedMedia : ''), 'shareonpinterest', 'width=' + this.settings.pinterest.width + ',height=' + this.settings.pinterest.height + ',resizable=yes');
                sharer.focus();
            }

        };

        share_module.init(settings);

        return share_module;
    }

    return ShareModule;
}));

